import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Calendar from "@/pages/Calendar";
import Customers from "@/pages/Customers";
import ProjectsDone from "@/pages/ProjectsDone";
import Reports from "@/pages/Reports";
import Finance from "@/pages/Finance";
import Payroll from "@/pages/Payroll";
import BusinessInfo from "@/pages/BusinessInfo";
import PrintJobOrder from "@/pages/PrintJobOrder";
import PrintInvoice from "@/pages/PrintInvoice";
import Settings from "@/pages/Settings";
import Quotation from "@/pages/Quotation";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/projects-done" element={<ProjectsDone />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/payroll" element={<Payroll />} />
              <Route path="/business-info" element={<BusinessInfo />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/print-job-order/:orderId" element={<PrintJobOrder />} />
              <Route path="/print-invoice/:orderId" element={<PrintInvoice />} />
              <Route path="/quotation" element={<Quotation />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
